import { render, staticRenderFns } from "./ContractCard.vue?vue&type=template&id=20daab70&scoped=true&"
import script from "./ContractCard.vue?vue&type=script&lang=js&"
export * from "./ContractCard.vue?vue&type=script&lang=js&"
import style0 from "./ContractCard.vue?vue&type=style&index=0&id=20daab70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20daab70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VHover,VRow})
